<template>
	<div class="com-mid-content text-white">
		<BlockBox height="620" :hasTitle="false">
			<template #content>
				<div style="padding-top: 5px;position: relative;">
					<div class="videoBox">
						<video :src="video" autoplay muted loop></video>
					</div>
				</div>
			</template>
		</BlockBox>
		<div class="margin-top-15">
			<BlockBox title="设备体验详情" enTitle="Equipment Experience Details" height="326">
				<template #content>
					<div style="padding:0 15px;box-sizing: border-box">
						<div class="sbxqBox margin-top-10">
							<el-row :gutter="20">
								<el-col :span="6">
									<div class="numItemBlock">
										<div class="item">
											<div class="title">设备在线数</div>
											<div class="num">{{centerData.machineOnlineCount}}</div>
										</div>
										<div class="item">
											<div class="title">考核次数</div>
											<div class="num">{{centerData.questionCount}}</div>
										</div>
										<div class="item">
											<div class="title">设备总数</div>
											<div class="num">{{centerData.machineCount}}</div>
										</div>
										<div class="item">
											<div class="title">考核通过次数</div>
											<div class="num">{{centerData.questionPassCount}}</div>
										</div>
									</div>
								</el-col>
								<el-col :span="18">
									<div class="swiper" id="quHszhSwiper">
										<div class="swiper-wrapper">
											<div class="swiper-slide" v-for="(obj,index) in stTyList" :key="index">
												<div class="sbItem">
													<div class="flex align-center justify-end text-green">
														<div class="circie"></div>
														<div>空闲中</div>
													</div>
													<div class="margin-top-10"
														style="width: 60px;margin:10px auto 0 auto;">
														<img :src="aedImg" style="width: 60px; height: 83px" />


													</div>
													<div class="base-font-16 margin-top-15">设备编码:A678007250-</div>
													<div class="base-font-16 margin-top-15">设备型号：A10</div>
													<div class="base-font-16 margin-top-15">登录用户：无</div>
													<div class="base-font-16 margin-top-15">设备地址：</div>
												</div>
											</div>
										</div>
									</div>
								</el-col>
							</el-row>

						</div>
					</div>
				</template>
			</BlockBox>
		</div>
	</div>
</template>

<script>
	import {
		centerData
	} from "@/api/api"
	import BlockBox from '@/views/components/blockBox'
	import 'swiper/swiper-bundle.min.css'
	import Swiper from 'swiper/swiper-bundle';
	export default {
		name: "cityGreenLand",
		components: {
			BlockBox
		},
		data() {
			return {
				item: {},
				circleImage: require("../../../assets/images/xsd/circle.png"),
				video: require("../../../assets/video.mp4"),
				aedImg: require("../../../assets/12.png"),
				// circleImage: '',
				colors: ['#f0792a', '#4b3eeb', '#247bf1', "#67e591", '#05d3f8', '#c0f02a', ],
				//编辑
				mySwiper: null,
				stTyList: [{
						id: 1
					},
					{
						id: 1
					},
					{
						id: 1
					},

				],
				centerData: {}
			}
		},
		mounted() {
			this.$nextTick(() => {
				this.initSbSwiper();
				this.getData()
			});
		},
		beforeDestroy() {
			clearTimeout(this.timerMid);
		},
		methods: {
			getData() {
				let _self = this
				centerData().then(res => {
					_self.centerData = res.data
					console.log(_self.centerData, 'resss111')
				})
			},
			initSbSwiper() {
				// 如果之前已经实例化过（例如数据更新），先销毁避免内存泄漏
				if (this.mySwiper) {
					this.mySwiper.destroy(true, true);
				}

				this.mySwiper = new Swiper('#quHszhSwiper', {
					autoplay: true,
					direction: 'horizontal', // 明确指定
					slidesPerView: 3,
					spaceBetween: 15,
					// 建议增加 loop: true 时的修复参数，防止 loop 模式下的滑动异常
					loop: true,
				});
			},
		}
	}
</script>

<style lang="scss" scoped>
	.com-mid-content {
		min-height: 200px;
		padding: 40px 5px 15px 5px;
		box-sizing: border-box;

		.numItemBlock {
			.item {
				width: 100%;
				box-shadow: 0 0 30px inset rgba(12, 51, 131, 0.6);
				padding: 12px 0;
				text-align: center;

				.title {
					font-size: 15px;
					font-weight: bold;
				}

				.num {
					color: #10d8cd;
					font-size: 20px;
					font-weight: bold;
					margin-top: 6px;
				}

				&+.item {
					margin-top: 10px;
				}
			}
		}

		.videoBox {
			width: 100%;
			height: 620px;
			margin-top: -5px;

			video {
				width: 100%;
				height: 620px;
				object-fit: cover;
			}
		}

		.sbxqBox {
			height: 260px;

			.circie {
				width: 10px;
				height: 10px;
				border-radius: 50%;
				background: #15ff15;
				margin-right: 6px;
			}

			&#quHszhSwiper {
				height: 260px;
				width: 100%;
				display: flex !important;
				flex-direction: row !important;

			}

			& #quHszhSwiper {
				height: 260px;
				width: 100%;
				// 防止初始化前的布局错乱
				display: flex;
				flex-direction: row;

				.swiper-wrapper {
					// 确保 wrapper 也是横向的
					display: flex;
					flex-direction: row;
				}
			}

			.swiper-slide {
				text-align: center;
				font-size: 18px;
				/* Center slide text vertically */
				display: -webkit-box;
				display: -ms-flexbox;
				display: -webkit-flex;
				display: flex;
				-webkit-box-pack: center;
				-ms-flex-pack: center;
				-webkit-justify-content: center;
				justify-content: center;
				-webkit-box-align: center;
				-ms-flex-align: center;
				-webkit-align-items: center;
				align-items: center;
			}
		}

		.sbItem {
			width: 100%;
			height: 260px;
			text-align: left;
			border: 1px solid #6291a8;
			padding: 10px;
			box-sizing: border-box;
		}

	}
</style>